export const ja = {
  'generator-title-apa6' : 'APA 6スタイルの引用・参考文献自動作成（無料）',
  'generator-title-apa7' : 'APA 7スタイルの引用・参考文献自動作成（無料）',
  'generator-title-mla7' : 'MLA 7スタイルの引用・参考文献自動作成（無料）',
  'generator-title-mla8' : 'MLA 8スタイルの引用・参考文献自動作成（無料）',
  'generator-title-chicago' : 'シカゴスタイルの引用・参考文献自動作成（無料）',
  'generator-title-vancouver' : 'バンクーバースタイルの引用・参考文献自動作成（無料）',
  'generator-description-apa6' : 'APA第6、7版の参考・引用文献を自動で作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！',
  'generator-description-apa7' : 'APA第6、7版の参考・引用文献を自動で作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！',
  'generator-description-mla7' : 'MLA第7、８版の参考・引用文献を自動で作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！',
  'generator-description-mla8' : 'MLA第7、８版の参考・引用文献を自動で作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！',
  'generator-description-chicago' : 'シカゴスタイル(第17 版)の参考文献を作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！',
  'generator-description-vancouver' : 'バンクーバースタイルの参考文献を作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！',
  'Brand Name' : 'Wordvice',
  'Citation Generator' : '引用・参考文献作成機',
  'Contributors': '著者',
  'Page Name' : 'ウェブページ名',
  'Site Name' : 'ウェブサイト名',
  'Date Published' : '出版日',
  'Date Accessed' : 'アクセス日',
  'Publisher' : '出版社',
  'Publisher Name' : '出版社名',
  'Publication Info' : '出版社情報',
  'Publication Location' : '発行地',
  'Publication Year' : '発行年',
  'Day' : '日',
  'Month' : '月',
  'Year' : '年',
  'Generate' : '作成する',
  'button_generate' : '作成する',
  'Copied.' : 'コピー完了',
  'copied_messgage' : 'コピー完了',
  'generate_result' : '生成结果',
  'Article Title' : '論文のタイトル',
  'Journal Title' : 'ジャーナル名',
  'Edition' : '版',
  'Volume' : '巻',
  'Issue' : '号',
  'Number' : '番号',
  'Pages' : 'ページ',
  'Website or Database Title' : 'ウェブサイト名またはデータベース名',
  'Title' : '表題',
  'Location' : '出版',
  'cite-Source' : '情報源',
  'cite-Style' : 'スタイル',
  'Copy' : 'コピー',
  'Delete' : '削除',
  'Number or name' : '数字又は名前',
  'source-Website' : 'ウェブサイト',
  'source-Journal Article' : '学術誌',
  'source-Book' : '書籍',
  'site_desc' : '引用・参考文献の情報入力のみで、必要なフォーマットに合わせた出典表記を自動で作成します。',
  'Example' : '例示',
  'Format' : 'フォーマット',
  'Citation Style Guides' : '引用・参考ガイド',
  'Author Last Name' : '著者の苗字',
  'Author First Name' : '著者の名前',
  'Author First Initial' : '名前のイニシャル',
  'Author Middle Name' : 'ミドルネーム',
  'Author Middle Initial' : 'ミドルネームのイニシャル',
  'Website Name' : 'ウェブサイト名',
  'Print' : '印刷物',
  'Digital' : '電子',
  'Page Title' : 'ウェブページ名',
  'Published Year' : '発行年',
  'Published Date' : '出版日',
  'citation-desc' : "ご希望のスタイルを選択して、必要な情報をすべてご入力ください。「作成する」 をクリックすると、フォーマットに合わせた参考文献が自動で作成されます。作成された参考文献は、引用・参考文献作成機の下に表示されますので、論文の参考文献(References)ページにコピーして貼り付けるだけで参考文献リストが完成します。すでに作成された参考文献は、リストから削除することもできます。",
  'author' : '著者',
  'editor' : 'エディター',
  'translator' : '翻訳家',
  'First Name' : '名前',
  'Middle' : 'ミドルネーム',
  'Last Name' : '苗字',
  'Quick Guides' : '参照・引用文献ガイド',
  'APA Citation Guide' : 'APA引用・参考文献ガイド',
  'MLA Citation Guide' : 'MLA引用・参考文献ガイド',
  'Chicago Citation Guide' : 'シカゴ式引用・参考文献ガイド',
  'Vancouver Citation Guide' : 'バンクーバー式引用・参考文献ガイド',
  'Style Guide Introduction' : '参照ジェネレーター',

  "apa" : {
    "page-title" : "APA スタイルの引用・参考文献自動作成（無料）",
    "page-description" : "APAの参考・引用文献を自動で作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！",
    "meta-title" : "APA方式/スタイルの引用・参考文献自動作成（無料）",
    "meta-description" : "APA第6、7版の参考・引用文献を自動で作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！",
  },

  "mla" : {
    "page-title" : "MLA スタイルの引用・参考文献自動作成（無料）",
    "page-description" : "MLAの参考・引用文献を自動で作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！",
    "meta-title" : "MLA方式/スタイルの引用・参考文献自動作成（無料）",
    "meta-description" : "MLA第7、８版の参考・引用文献を自動で作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！",
  },

  "chicago" : {
    "page-title" : "シカゴスタイルの引用・参考文献自動作成（無料）",
    "page-description" : "シカゴスタイル(第17 版)の参考文献を作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！",
    "meta-title" : "シカゴ方式/スタイルの引用・参考文献自動作成（無料）",
    "meta-description" : "シカゴスタイル(第17 版)の参考文献を作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！",
  },

  "vancouver" : {
    "page-title" : "バンクーバースタイルの引用・参考文献自動作成（無料）",
    "page-description" : "バンクーバースタイルの参考文献を作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！",
    "meta-title" : "バンクーバー方式/スタイルの引用・参考文献自動作成（無料）",
    "meta-description" : "バンクーバースタイルの参考文献を作成。書籍、学術誌、ウェブの文献情報を入力すると書式に合わせて自動的に作成されるので、コピー＆ペーストするだけ。簡単・便利で広告もありません！",
  },

  // sidebar
  "Citation Sources" : "Citation Sources",
  "citation_sources" : {
    "link1" : {
      "uri" : "https://blog.wordvice.jp/youtube-video-citation-apa-mla-chicago-vancouver/",
      "title" : "YouTube ビデオの引用方法",
    },
    "link2" : {
      "uri" : "https://blog.wordvice.jp/how-to-cite-images-apa-mla-chicago-vancouver/",
      "title" : "画像の引用方法",
    },
    "link3" : {
      "uri" : "https://blog.wordvice.jp/how-to-cite-movie-apa-mla-chicago-vancouver/",
      "title" : "映画の引用方法",
    },
    "link4" : {
      "uri" : "https://blog.wordvice.jp/how-to-cite-a-website-apa-mla-chicago-vancouver/",
      "title" : "ウエブサイトの引用方法",
    },
    "link5" : {
      "uri" : "https://blog.wordvice.jp/how-to-cite-a-podcast-apa-mla-chicago-vancouver/",
      "title" : "ポッドキャストの引用方法",
    },
    "link6" : {
      "uri" : "https://blog.wordvice.jp/how-to-cite-chatgpt-sources-apa-mla-chicago-vancouver/",
      "title" : "ChatGPTの引用方法",
    },
    "link7" : {
      "uri" : "https://blog.wordvice.jp/academic-how-to-cite-a-book-apa-mla-chicago-vancouver-style/",
      "title" : "書籍の引用方法",
    },
  }
};



// WEBPACK FOOTER //
// ./src/lang/ja.js